/**
 * @param {Observable<Config>} consumerConfig$
 * @param {Store<Config>} configStore
 * @return {Subscription}
 */

const subscribeToConsumerConfig = (
    consumerConfig$,
    configStore
) =>
    consumerConfig$
        .subscribe(nextConsumerOptions => configStore.actions.configure(nextConsumerOptions));

export default subscribeToConsumerConfig;
